<template>
  <v-container style="margin-top: -70px">
    <v-layout row wrap>
      <v-flex md8 xs12 d-flex>
        <v-layout row wrap>
          <v-flex xs12 pa-1>
            <p style="color: red" name="error-message">{{ error_message }}</p>
            <v-card flat style="background-color: transparent">
              <v-card-title>
                <h5 class="headline">Increase Storage</h5>
              </v-card-title>
              <v-layout row wrap>
                <v-flex pl-3 sm6 xs12>
                  <v-text-field
                    :rules="storageSizeRule"
                    readonly
                    :value="
                      cluster_info.disk_size *
                      cluster_info.num_disk *
                      (cluster_info.num_node + cluster_info.num_reserve_node + cluster_modifications.add_node)
                    "
                    label="Current storage capacity (in GB)"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex pl-3 sm6 xs12>
                  <v-text-field
                    v-model="cluster_modifications.increase_storage"
                    :rules="[
                      (cluster_modifications.increase_storage >= 0 &&
                        !Number.isInteger(cluster_modifications.increase_storage)) ||
                        'Only positive values allowed',
                    ]"
                    label="New additional storage capacity (in GB)"
                    hint="The additional storage capacity is equally distributed about all existing nodes"
                    type="number"
                    @input="inputmodelchanged()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 pa-1>
            <v-card flat style="background-color: transparent">
              <v-card-title>
                <h5 class="headline">Scale Up/Down (change instance models)</h5>
              </v-card-title>
              <v-layout row wrap>
                <v-flex pl-3 sm6 xs12>
                  <v-text-field
                    v-model="cluster_info.instance_type"
                    readonly
                    label="Current instance model"
                  ></v-text-field>
                </v-flex>
                <v-flex pl-3 sm6 xs12>
                  <v-select
                    v-model="cluster_info.instance_family"
                    color="secondary"
                    :items="cluster_info.instance_families"
                    label="Instances familiy"
                    @change="
                      instance_family_changed();
                      inputmodelchanged();
                    "
                  ></v-select>
                  <v-select
                    v-model="cluster_modifications.instance_type"
                    color="secondary"
                    :items="cluster_info.instance_types"
                    label="New instance model"
                    @change="inputmodelchanged()"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 pa-1>
            <v-card flat style="background-color: transparent">
              <v-card-title>
                <h5 class="headline">Scale Out (add nodes)</h5>
                &nbsp;&nbsp;&nbsp;
                <v-tooltip right
                  ><v-icon slot="activator">help</v-icon
                  ><span
                    >Click on the expand button to get further information on the scale out and reorganize
                    operations</span
                  ></v-tooltip
                >
                <v-btn flat fab small @click="helper_sections_add_node = !helper_sections_add_node"
                  ><v-icon>{{ !helper_sections_add_node ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon></v-btn
                >
              </v-card-title>
              <v-layout row wrap>
                <v-flex pl-3 sm6 xs12>
                  <v-text-field
                    v-model="cluster_info.num_node"
                    readonly
                    label="Current number of DB nodes"
                  ></v-text-field>
                </v-flex>
                <v-flex pl-3 sm3 xs12>
                  <v-select
                    v-model="cluster_modifications.add_node"
                    color="secondary"
                    :items="[0, 1, 2, 3, 4, 5]"
                    label="Add additional node(s)"
                    @change="inputmodelchanged()"
                  ></v-select>
                </v-flex>
                <v-flex pl-3 sm3 xs12>
                  <v-checkbox v-model="add_as_reserve_node" label="Add as reserve node" hide-details></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout v-show="helper_sections_add_node && !add_as_reserve_node" row wrap>
                <v-flex pl-3 xs12 class="text-xs-left">
                  This operation enlarges the cluster and the DB and might take some time due to the following actions:
                  <ul>
                    <li>
                      creating the number of instances in
                      {{ cluster_info.cloud_platform }}
                    </li>
                    <li>configuring the instance in the cluster and configuring the exasol software</li>
                    <li>
                      adding the instance to the DB and enlarging it afterwards with the added nodes, this requires a
                      short downtime
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
              <v-layout v-show="helper_sections_add_node && add_as_reserve_node" row wrap>
                <v-flex pl-3 xs12 class="text-xs-left">
                  This operation enlarges the cluster and might take some time due to the following actions:
                  <ul>
                    <li>
                      creating the number of instances in
                      {{ cluster_info.cloud_platform }}
                    </li>
                    <li>configuring the instance in the cluster and configuring the exasol software</li>
                  </ul>
                </v-flex>
              </v-layout>
              <v-layout v-show="!add_as_reserve_node" row wrap>
                <v-flex pl-3 sm6 xs12>
                  <v-checkbox
                    v-model="reorganize_method"
                    label="Reorganize database"
                    value="Reorganize"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex pl-3 sm6 xs12>
                  <v-text-field
                    v-model="password_sys"
                    :rules="[reorganize_method == null || password_sys != '' || 'Password required']"
                    :append-icon="show_password ? 'visibility_off' : 'visibility'"
                    :type="show_password ? 'text' : 'password'"
                    label="Password for DB user sys"
                    hint="Enter password for DB user sys"
                    required
                    @click:append="show_password = !show_password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout v-show="helper_sections_add_node && !add_as_reserve_node" row wrap>
                <v-flex pl-3 xs12 class="text-xs-left">
                  This operation reorganizes your data equally on your db volumes.<br />
                  During this action the database can still be used, though with reduced performance.<br />
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex md4 xs12 pt-3 pl-5>
        <v-card flat style="background-color: transparent">
          <v-layout row wrap pl-3>
            <v-flex xs3> </v-flex>
            <v-flex xs4>
              <p class="text-xs-left font-weight-bold">Current value</p>
            </v-flex>
            <v-flex xs5>
              <p class="text-xs-left font-weight-bold">New value</p>
            </v-flex>
          </v-layout>

          <v-layout row wrap pa-4>
            <v-flex xs3>
              <h5 class="body-2 text-xs-left font-weight-bold">&Sigma; Storage</h5>
            </v-flex>
            <v-flex xs4>
              <p class="text-xs-left">
                {{
                  cluster_info.disk_size *
                  cluster_info.num_disk *
                  (cluster_info.num_node + cluster_info.num_reserve_node)
                }}
                GB
              </p>
            </v-flex>
            <v-flex xs4>
              <p
                class="text-xs-left"
                :style="
                  cluster_info.disk_size *
                    cluster_info.num_disk *
                    (cluster_info.num_node + cluster_info.num_reserve_node + cluster_modifications.add_node) <
                  (cluster_info.disk_size *
                    cluster_info.num_disk *
                    (cluster_info.num_node + cluster_info.num_reserve_node + cluster_modifications.add_node) +
                    parseFloat(cluster_modifications.increase_storage)) *
                    ((cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) /
                      (cluster_info.num_node + cluster_info.num_reserve_node))
                    ? 'color: green'
                    : 'opacity: 0.0'
                "
              >
                {{
                  isNaN(
                    (
                      cluster_info.disk_size *
                        cluster_info.num_disk *
                        (cluster_info.num_node + cluster_info.num_reserve_node + cluster_modifications.add_node) +
                      (parseFloat(cluster_modifications.increase_storage) *
                        (cluster_info.num_node + cluster_modifications.add_node)) /
                        cluster_info.num_node
                    ).toFixed(2)
                  )
                    ? '-'
                    : (
                        cluster_info.disk_size *
                          cluster_info.num_disk *
                          (cluster_info.num_node + cluster_info.num_reserve_node + cluster_modifications.add_node) +
                        (parseFloat(cluster_modifications.increase_storage) *
                          (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node)) /
                          (cluster_info.num_node + cluster_info.num_reserve_node)
                      ).toFixed(0)
                }}
                GB
              </p>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap pa-4>
            <v-flex xs3>
              <h5 class="body-2 text-xs-left font-weight-bold">&Sigma; vCPU:</h5>
            </v-flex>
            <v-flex xs4>
              <p class="text-xs-left">
                {{ (cluster_info.num_node + cluster_info.num_reserve_node) * instance_info.cpu }}
                x
              </p>
            </v-flex>
            <v-flex xs4>
              <p
                class="text-xs-left"
                :style="
                  (cluster_info.num_node + +cluster_info.num_reserve_node) * instance_info.cpu >
                  (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) *
                    instance_info_modifications.cpu
                    ? 'color: red'
                    : (cluster_info.num_node + cluster_info.num_reserve_node) * instance_info.cpu <
                      (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) *
                        instance_info_modifications.cpu
                    ? 'color: green'
                    : 'opacity: 0.0'
                "
              >
                {{
                  isNaN(
                    (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) *
                      instance_info_modifications.cpu
                  )
                    ? '-'
                    : (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) *
                      instance_info_modifications.cpu
                }}
                x
              </p>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap pa-4>
            <v-flex xs3>
              <h5 class="body-2 text-xs-left font-weight-bold">&Sigma; Memory</h5>
            </v-flex>
            <v-flex xs4>
              <p class="text-xs-left">
                {{ (cluster_info.num_node + cluster_info.num_reserve_node) * instance_info.memory }}
                GB
              </p>
            </v-flex>
            <v-flex xs4>
              <p
                class="text-xs-left"
                :style="
                  (cluster_info.num_node + cluster_info.num_reserve_node) * instance_info.memory >
                  (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) *
                    instance_info_modifications.memory
                    ? 'color: red'
                    : (cluster_info.num_node + cluster_info.num_reserve_node) * instance_info.memory <
                      (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) *
                        instance_info_modifications.memory
                    ? 'color: green'
                    : 'opacity: 0.0'
                "
              >
                {{
                  isNaN(
                    (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) *
                      instance_info_modifications.memory
                  )
                    ? '-'
                    : (cluster_info.num_node + cluster_modifications.add_node + cluster_info.num_reserve_node) *
                      instance_info_modifications.memory
                }}
                GB
              </p>
            </v-flex>
            <v-checkbox v-model="set_db_ram_automatically" label="Set DB ram automatically" hide-details></v-checkbox>
            <v-text-field
              v-model="db_ram"
              :readonly="set_db_ram_automatically"
              label="DB ram (in GB)"
              type="number"
              :rules="[(db_ram >= 0 && !Number.isInteger(db_ram)) || 'Only positive values allowed']"
            ></v-text-field>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap pa-4>
            <v-flex xs3>
              <h5 class="body-2 text-xs-left font-weight-bold">&Sigma; DB Nodes</h5>
            </v-flex>
            <v-flex xs4>
              <p class="text-xs-left">
                {{ cluster_info.num_node }}
                {{ cluster_info.num_reserve_node > 0 ? `( + ${cluster_info.num_reserve_node} reserve)` : '' }}
              </p>
            </v-flex>
            <v-flex xs4>
              <!-- ERRORRRR -->
              <p
                class="text-xs-left"
                :style="
                  cluster_info.num_node < cluster_info.num_node + cluster_modifications.add_node
                    ? 'color: green'
                    : 'opacity: 0.0'
                "
              >
                {{ cluster_info.num_node + (add_as_reserve_node ? 0 : cluster_modifications.add_node) }}
                {{
                  cluster_info.num_reserve_node > 0 || add_as_reserve_node
                    ? `( + ${
                        cluster_info.num_reserve_node + (add_as_reserve_node ? cluster_modifications.add_node : 0)
                      } reserve)`
                    : ''
                }}
              </p>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>

          <v-layout row wrap pa-4>
            <v-flex xs12 pb-3>
              <h5 class="body-2 text-xs-left font-weight-bold">
                Cost&nbsp;<v-tooltip right
                  ><v-icon slot="activator" small>info</v-icon
                  ><span>An existing Management Node is not included in the listed costs</span></v-tooltip
                >
              </h5>
            </v-flex>
            <v-flex xs3>
              <h5 class="body-2 text-xs-left">Compute:</h5>
            </v-flex>
            <v-flex xs4>
              <p class="text-xs-left">{{ summaryCosts.Compute.old }} $/hour</p>
            </v-flex>
            <v-flex xs4>
              <p
                class="text-xs-left"
                :style="
                  summaryCosts.Compute.old < summaryCosts.Compute.new
                    ? 'color: red'
                    : summaryCosts.Compute.old > summaryCosts.Compute.new
                    ? 'color: green'
                    : 'opacity: 0.0'
                "
              >
                {{ summaryCosts.Compute.new }} $/hour
              </p>
            </v-flex>
            <v-flex xs3>
              <h5 class="body-2 text-xs-left">Storage:</h5>
            </v-flex>
            <v-flex xs4>
              <p class="text-xs-left">{{ summaryCosts.Storage.old }} $/hour</p>
            </v-flex>
            <v-flex xs4>
              <p
                class="text-xs-left"
                :style="
                  summaryCosts.Storage.old < summaryCosts.Storage.new
                    ? 'color: red'
                    : summaryCosts.Storage.old > summaryCosts.Storage.new
                    ? 'color: green'
                    : 'opacity: 0.0'
                "
              >
                {{ summaryCosts.Storage.new }} $/hour
              </p>
            </v-flex>
            <v-flex xs3>
              <h5 class="body-2 text-xs-left">Exasol SW:</h5>
            </v-flex>
            <v-flex xs4>
              <p class="text-xs-left">{{ summaryCosts.Software.old }} $/hour</p>
            </v-flex>
            <v-flex xs4>
              <p
                class="text-xs-left"
                :style="
                  summaryCosts.Software.old < summaryCosts.Software.new
                    ? 'color: red'
                    : summaryCosts.Software.old > summaryCosts.Software.new
                    ? 'color: green'
                    : 'opacity: 0.0'
                "
              >
                {{ summaryCosts.Software.new }} $/hour
              </p>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>

          <v-layout row wrap pa-4>
            <v-flex xs12 pb-3>
              <h5 class="body-2 text-xs-left font-weight-bold">
                Shutdown/Startup Cluster Nodes&nbsp;<v-tooltip right
                  ><v-icon slot="activator" small>info</v-icon
                  ><span>All nodes except the Management Node will be shutdown/started up</span></v-tooltip
                >
              </h5>
            </v-flex>
            <v-flex xs12>
              <v-btn color="accent" class="black--text" large @click.native="startupshutdownNodes('start_cluster')"
                >Startup</v-btn
              >
              <v-btn color="error" class="black--text" large @click.native="startupshutdownNodes('stop_cluster')"
                >Shutdown</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-flex xs12 pa-2>
      <v-btn
        :disabled="
          !(
            cluster_modifications.increase_storage > 0 ||
            cluster_modifications.add_node > 0 ||
            cluster_info.instance_type != cluster_modifications.instance_type ||
            reorganize_method != null ||
            password_sys != ''
          )
        "
        color="primary"
        class="black--text"
        large
        @click.native="resetView"
        >Refresh</v-btn
      >
      <v-btn
        :disabled="
          !(
            cluster_modifications.increase_storage > 0 ||
            cluster_modifications.add_node > 0 ||
            cluster_info.instance_type != cluster_modifications.instance_type ||
            (password_sys != '' && reorganize_method != null)
          ) ||
          (password_sys == '' && reorganize_method != null)
        "
        color="primary"
        class="black--text"
        large
        @click.native="
          apply_dialog = true;
          modification_cluster.enlarge_disks.running ||
          modification_cluster.add_node.running ||
          modification_cluster.change_instance_type.running
            ? ''
            : (modification_cluster.enlarge_disks.response = '');
          modification_cluster.change_instance_type.response = '';
          modification_cluster.add_node.response = '';
          modification_cluster.reorganize.response = '';
        "
        >Apply</v-btn
      >
    </v-flex>

    <Loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true"></Loading>

    <v-dialog
      v-model="apply_dialog"
      :width="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? '100%' : '40%'"
    >
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 pa-2
            ><p class="headline">Apply changes in {{ cluster_info.cloud_platform }}</p></v-flex
          >

          <!-- Headers -->
          <v-flex xs5 pa-1>Action</v-flex>
          <v-flex xs6 pa-1> Result</v-flex>
          <v-flex xs1 pa-1></v-flex>

          <!-- Enlarge Disks -->
          <v-flex v-if="cluster_modifications.increase_storage > 0" xs5 pa-1>
            Increasing overall storage for
            <b>{{ cluster_modifications.increase_storage }} GB</b>
          </v-flex>
          <v-flex v-if="cluster_modifications.increase_storage > 0" xs6 pa-1>
            {{ modification_cluster.enlarge_disks.response }}
          </v-flex>
          <v-flex v-if="cluster_modifications.increase_storage > 0" xs1 pa-1>
            <v-progress-circular
              v-if="!modification_cluster.enlarge_disks.running && modification_cluster.enlarge_disks.response == ''"
              :size="30"
            ></v-progress-circular>
            <v-progress-circular
              v-if="modification_cluster.enlarge_disks.running"
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-icon
              v-if="modification_cluster.enlarge_disks.response.includes('successful')"
              dark
              flat
              color="primary"
              large
              >check_circle</v-icon
            >
            <v-icon v-if="modification_cluster.enlarge_disks.response.includes('Error:')" dark flat color="red" large
              >cancel</v-icon
            >
          </v-flex>

          <!-- Add node -->
          <v-flex v-if="cluster_modifications.add_node > 0" xs5 pa-1>
            <span v-if="!add_as_reserve_node">DB nodes to be added:</span>
            <span v-if="add_as_reserve_node">Reserve nodes to be added:</span>
            <b>{{ cluster_modifications.add_node }}</b>
          </v-flex>
          <v-flex v-if="cluster_modifications.add_node > 0" xs6 pa-1>
            {{ modification_cluster.add_node.response }}
          </v-flex>
          <v-flex v-if="cluster_modifications.add_node > 0" xs1 pa-1>
            <v-progress-circular
              v-if="!modification_cluster.add_node.running && modification_cluster.add_node.response == ''"
              :size="30"
            ></v-progress-circular>
            <v-progress-circular
              v-if="modification_cluster.add_node.running"
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-icon v-if="modification_cluster.add_node.response.includes('successful')" dark flat color="primary" large
              >check_circle</v-icon
            >
            <v-icon v-if="modification_cluster.add_node.response.includes('Error:')" dark flat color="red" large
              >cancel</v-icon
            >
          </v-flex>

          <!-- Change instance type -->
          <v-flex v-if="cluster_info.instance_type != cluster_modifications.instance_type" xs5 pa-1>
            Changing instance types to:
            <b>{{ cluster_modifications.instance_type }}</b>
          </v-flex>
          <v-flex v-if="cluster_info.instance_type != cluster_modifications.instance_type" xs6 pa-1>
            {{ modification_cluster.change_instance_type.response }}
          </v-flex>
          <v-flex v-if="cluster_info.instance_type != cluster_modifications.instance_type" xs1 pa-1>
            <v-progress-circular
              v-if="
                !modification_cluster.change_instance_type.running &&
                modification_cluster.change_instance_type.response == ''
              "
              :size="30"
            ></v-progress-circular>
            <v-progress-circular
              v-if="modification_cluster.change_instance_type.running"
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-icon
              v-if="modification_cluster.change_instance_type.response.includes('successful')"
              dark
              flat
              color="primary"
              large
              >check_circle</v-icon
            >
            <v-icon
              v-if="modification_cluster.change_instance_type.response.includes('Error:')"
              dark
              flat
              color="red"
              large
              >cancel</v-icon
            >
          </v-flex>

          <!-- Reorganize Database -->
          <v-flex v-if="reorganize_method != null" xs5 pa-1>
            Reorganize database:
            <b>{{ reorganize_method }}</b>
          </v-flex>
          <v-flex v-if="reorganize_method != null" xs6 pa-1>
            {{ modification_cluster.reorganize.response }}
          </v-flex>
          <v-flex v-if="reorganize_method != null" xs1 pa-1>
            <v-progress-circular
              v-if="!modification_cluster.reorganize.running && modification_cluster.reorganize.response == ''"
              :size="30"
            ></v-progress-circular>
            <v-progress-circular
              v-if="modification_cluster.reorganize.running"
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-icon
              v-if="modification_cluster.reorganize.response.includes('successful')"
              dark
              flat
              color="primary"
              large
              >check_circle</v-icon
            >
            <v-icon v-if="modification_cluster.reorganize.response.includes('Error:')" dark flat color="red" large
              >cancel</v-icon
            >
          </v-flex>
        </v-layout>
        <v-card-actions class="text-xs-center">
          <v-spacer></v-spacer>
          <v-btn @click="apply_dialog = false">Close</v-btn>
          <v-btn
            :disabled="
              modification_cluster.enlarge_disks.running ||
              modification_cluster.add_node.running ||
              modification_cluster.change_instance_type.running
            "
            @click="
              applyChanges();
              modification_cluster.enlarge_disks.response = '';
              modification_cluster.add_node.response = '';
              modification_cluster.change_instance_type.response = '';
              modification_cluster.reorganize.response = '';
            "
            >Execute</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Loading from 'vue-loading-overlay';
import xmlrpcservice from '@/service/xmlrpc-service';
import sizing_selection from '@/assets/sizing_selection.json';
import license_cost from '@/assets/license_cost_ram.json';
import resource_metadata_service from '@/service/resource-metadata-service';
import { setTimeout } from 'timers';
import axios from 'axios';

export default {
  name: 'ClusterModificator',
  components: {
    Loading,
  },
  data() {
    return {
      cluster_info: {
        cloud_platform: null,
        region: null,
        instance_type: null,
        current_storage: 1,
        instance_families: null,
        instance_family: null,
        instance_types: null,
        disk_type: null,
        disk_size: null,
        num_node: 0,
        num_reserve_node: 0,
      },
      cluster_modifications: {
        add_node: 0,
        increase_storage: 0,
        instance_type: null,
        license: 0,
      },
      instance_info: { vcpu: 0, memory: 0, cost: 0 },
      instance_info_modifications: { vcpu: 0, memory: 0, cost: 0 },
      summaryCosts: {
        Compute: { old: 0, new: 0 },
        Storage: { old: 0, new: 0 },
        Software: { old: 0, new: 0 },
      },
      isLoading: true,
      apply_dialog: false,
      reorganize_dialog: false,
      add_as_reserve_node: false,
      reorganize_method: null,
      password_sys: '',
      show_password: false,
      helper_sections_add_node: false,
      storageSizeRule: [(v) => /^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/.test(v) || 'Only positiv values allowed'],
      modification_cluster: {
        enlarge_disks: { response: '', running: false },
        change_instance_type: { response: '', running: false },
        add_node: { response: '', running: false },
        reorganize: { response: '', running: false },
      },
      error_message: '',
      set_db_ram_automatically: true,
      db_ram: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      xmlrpcservice.callPlugin(
        JSON.stringify({
          method: 'get_cluster_information',
          credentials: localStorage.credentials.split('Basic ')[1],
        }),
        (value) => {
          try {
            this.cluster_info = Object.assign(
              { add_node: 0, increase_storage: 0 },
              JSON.parse(value[1].split('###_###')[1])
            );
            this.error_message = '';
          } catch (e) {
            this.error_message = value;
            this.isLoading = false;
          }
          this.cluster_info.instance_families = Object.keys(
            sizing_selection['BYOL'][this.cluster_info.cloud_platform]['instances']
          );
          this.cluster_info.instance_families.forEach((x) => {
            if (
              sizing_selection['BYOL'][this.cluster_info.cloud_platform].instances[x].includes(
                this.cluster_info.instance_type
              )
            ) {
              this.cluster_info.instance_family = x;
              this.cluster_info.instance_types =
                sizing_selection['BYOL'][this.cluster_info.cloud_platform]['instances'][
                  this.cluster_info.instance_family
                ];
            }
          });
          this.cluster_modifications.instance_type = this.cluster_info.instance_type;
          try {
            let resource_metadata = resource_metadata_service.get_vm_metadata(
              this.cluster_info.cloud_platform,
              this.cluster_info.region,
              this.cluster_info.instance_type
            );
            this.instance_info.cpu = parseFloat(resource_metadata['cpu']);
            this.instance_info.memory = parseFloat(resource_metadata['memory']);
            this.instance_info.price = parseFloat(resource_metadata['price']).toFixed(2);
            this.instance_info.license_cost = parseFloat(
              license_cost.filter((x) => x.ram >= this.instance_info.memory)[0]['price'].toFixed(2)
            );
            this.instance_info_modifications.cpu = this.instance_info.cpu;
            this.instance_info_modifications.memory = this.instance_info.memory;
            this.instance_info_modifications.price = this.instance_info.price;
            this.instance_info_modifications.license_cost = this.instance_info.license_cost;

            this.summaryCosts.Compute.old = parseFloat(
              (this.instance_info.price * (this.cluster_info.num_node + this.cluster_info.num_reserve_node)).toFixed(2)
            );
            this.summaryCosts.Storage.old = parseFloat(
              (
                (this.cluster_info.disk_size *
                  this.cluster_info.num_disk *
                  (this.cluster_info.num_node + this.cluster_info.num_reserve_node) *
                  0.12) /
                (24 * 30)
              ).toFixed(2)
            );
            this.summaryCosts.Software.old = parseFloat(
              (
                this.instance_info.license_cost *
                (this.cluster_info.num_node + this.cluster_info.num_reserve_node)
              ).toFixed(2)
            );
            this.summaryCosts.Compute.new = this.summaryCosts.Compute.old;
            this.summaryCosts.Storage.new = this.summaryCosts.Storage.old;
            this.summaryCosts.Software.new = this.summaryCosts.Software.old;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.warn(e);
          }
          this.inputmodelchanged();
          this.isLoading = false;
        }
      );
    },
    instance_family_changed() {
      this.cluster_info.instance_types =
        sizing_selection['BYOL'][this.cluster_info.cloud_platform]['instances'][this.cluster_info.instance_family];
      this.cluster_modifications.instance_type = this.cluster_info.instance_types[0];
    },

    inputmodelchanged() {
      try {
        let resource_metadata = resource_metadata_service.get_vm_metadata(
          this.cluster_info.cloud_platform,
          this.cluster_info.region,
          this.cluster_modifications.instance_type
        );
        this.instance_info_modifications.cpu = parseFloat(resource_metadata['cpu']);
        this.instance_info_modifications.memory = parseFloat(resource_metadata['memory']);
        this.instance_info_modifications.price = parseFloat(resource_metadata['price']).toFixed(2);
        this.instance_info_modifications.license_cost = parseFloat(
          license_cost.filter((x) => x.ram >= this.instance_info_modifications.memory)[0]['price'].toFixed(2)
        );

        this.summaryCosts.Compute.new = parseFloat(
          (
            this.instance_info_modifications.price *
            (this.cluster_info.num_node + this.cluster_modifications.add_node + this.cluster_info.num_reserve_node)
          ).toFixed(2)
        );
        this.summaryCosts.Storage.new = parseFloat(
          (
            ((this.cluster_info.disk_size *
              this.cluster_info.num_disk *
              (this.cluster_info.num_node + this.cluster_info.num_reserve_node + this.cluster_modifications.add_node) +
              parseFloat(this.cluster_modifications.increase_storage) *
                ((this.cluster_info.num_node +
                  this.cluster_modifications.add_node +
                  this.cluster_info.num_reserve_node) /
                  (this.cluster_info.num_node + this.cluster_info.num_reserve_node))) *
              0.12) /
            (24 * 30)
          ).toFixed(2)
        );
        this.summaryCosts.Software.new = parseFloat(
          (
            this.instance_info_modifications.license_cost *
            (this.cluster_info.num_node + this.cluster_modifications.add_node + this.cluster_info.num_reserve_node)
          ).toFixed(2)
        );
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
      }
    },

    applyChanges() {
      return new Promise((resolve) => {
        if (this.cluster_modifications.increase_storage > 0) {
          this.modification_cluster.enlarge_disks.running = true;
          let new_disk_size =
            this.cluster_info.disk_size +
            parseInt(
              this.cluster_modifications.increase_storage / (this.cluster_info.num_node * this.cluster_info.num_disk)
            );
          let randomString = Math.random().toString(34).substring(2);
          xmlrpcservice.scalingRequest(
            JSON.stringify({
              method: 'set_new_data_disk_size',
              value: new_disk_size,
              credentials: localStorage.credentials.split('Basic ')[1],
            }),
            randomString
          );

          let sleep = (time) => new Promise((resolve1) => setTimeout(resolve1, time));
          let done = false;
          let poll = (promiseFn, time) => {
            if (!done) {
              return promiseFn().then(sleep(time).then(() => poll(promiseFn, time)));
            }
          };
          let timeout = new Date().getTime() + 1800000;
          let timeout_reached;

          poll(
            () =>
              new Promise(() =>
                axios.post(`${localStorage.proxyURL}/scalingrequestinfo/${randomString}`).then((response) => {
                  timeout_reached = timeout < new Date().getTime();
                  if (response.data != '' || timeout_reached) {
                    done = true;
                    this.modification_cluster.enlarge_disks.running = false;
                    this.modification_cluster.enlarge_disks.response = timeout_reached
                      ? 'Error: timeout'
                      : response.data.split('###_###')[1];
                    resolve('Successfully increased storage size');
                  }
                })
              ),
            20000
          );
        } else {
          resolve('Resizing disks passed');
        }
      })
        .then(() => {
          return new Promise((resolve) => {
            if (this.cluster_modifications.add_node > 0) {
              this.modification_cluster.add_node.running = true;
              let randomString = Math.random().toString(34).substring(2);
              xmlrpcservice.scalingRequest(
                JSON.stringify({
                  method: 'add_nodes',
                  number: this.cluster_modifications.add_node,
                  add_as_reserve_node: this.add_as_reserve_node,
                  db_ram: this.set_db_ram_automatically ? '' : this.db_ram,
                  credentials: localStorage.credentials.split('Basic ')[1],
                }),
                randomString
              );

              let sleep = (time) => new Promise((resolve1) => setTimeout(resolve1, time));
              let done = false;
              let poll = (promiseFn, time) => {
                if (!done) {
                  return promiseFn().then(sleep(time).then(() => poll(promiseFn, time)));
                }
              };
              let timeout = new Date().getTime() + 1800000 * this.cluster_modifications.add_node;
              let timeout_reached;

              poll(
                () =>
                  new Promise(() =>
                    axios.post(`${localStorage.proxyURL}/scalingrequestinfo/${randomString}`).then((response) => {
                      timeout_reached = timeout < new Date().getTime();
                      if (response.data != '' || timeout_reached) {
                        done = true;
                        this.modification_cluster.add_node.running = false;
                        this.modification_cluster.add_node.response = timeout_reached
                          ? 'Error: timeout'
                          : response.data.split('###_###')[1];
                        resolve('Successfully added node');
                      }
                    })
                  ),
                20000
              );
            } else {
              resolve('Adding nodes passed');
            }
          });
        })
        .then(() => {
          return new Promise((resolve) => {
            if (this.cluster_info.instance_type != this.cluster_modifications.instance_type) {
              this.modification_cluster.change_instance_type.running = true;
              let randomString = Math.random().toString(34).substring(2);
              xmlrpcservice.scalingRequest(
                JSON.stringify({
                  method: 'change_instance_type',
                  value: this.cluster_modifications.instance_type,
                  db_ram: this.set_db_ram_automatically ? '' : this.db_ram,
                  credentials: localStorage.credentials.split('Basic ')[1],
                }),
                randomString
              );

              let sleep = (time) => new Promise((resolve1) => setTimeout(resolve1, time));
              let done = false;
              let poll = (promiseFn, time) => {
                if (!done) {
                  return promiseFn().then(sleep(time).then(() => poll(promiseFn, time)));
                }
              };
              let timeout = new Date().getTime() + 1800000;
              let timeout_reached;

              poll(
                () =>
                  new Promise(() =>
                    axios.post(`${localStorage.proxyURL}/scalingrequestinfo/${randomString}`).then((response) => {
                      timeout_reached = timeout < new Date().getTime();
                      if (response.data != '' || timeout_reached) {
                        done = true;
                        this.modification_cluster.change_instance_type.running = false;
                        this.modification_cluster.change_instance_type.response = timeout_reached
                          ? 'Error: timeout'
                          : response.data.split('###_###')[1];
                        resolve('Instances successfully modified.');
                      }
                    })
                  ),
                20000
              );
            } else {
              resolve('Instances modification passed');
            }
          });
        })
        .then(() => {
          return new Promise((resolve) => {
            if (this.reorganize_method != null) {
              this.modification_cluster.reorganize.running = true;
              let randomString = Math.random().toString(34).substring(2);
              xmlrpcservice.scalingRequest(
                JSON.stringify({
                  method: 'reorganize_database',
                  db_password: this.password_sys,
                  reorganize_method: this.reorganize_method,
                  credentials: localStorage.credentials.split('Basic ')[1],
                }),
                randomString
              );

              let sleep = (time) => new Promise((resolve1) => setTimeout(resolve1, time));
              let done = false;
              let poll = (promiseFn, time) => {
                if (!done) {
                  return promiseFn().then(sleep(time).then(() => poll(promiseFn, time)));
                }
              };
              let timeout = new Date().getTime() + 1800000;
              let timeout_reached;

              poll(
                () =>
                  new Promise(() =>
                    axios.post(`${localStorage.proxyURL}/scalingrequestinfo/${randomString}`).then((response) => {
                      timeout_reached = timeout < new Date().getTime();
                      if (response.data != '' || timeout_reached) {
                        done = true;
                        this.modification_cluster.reorganize.running = false;
                        this.modification_cluster.reorganize.response = timeout_reached
                          ? 'Error: timeout'
                          : response.data.split('###_###')[1];
                        resolve('Database successfully reorganized.');
                      }
                    })
                  ),
                20000
              );
            } else {
              resolve('Instances modification passed');
            }
          });
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.warn(e);
        });
    },

    resetView() {
      this.cluster_modifications.add_node = 0;
      this.cluster_modifications.increase_storage = 0;
      this.modification_cluster.enlarge_disks.running = false;
      this.modification_cluster.add_node.running = false;
      this.modification_cluster.change_instance_type.running = false;
      this.modification_cluster.reorganize.running = false;

      this.isLoading = true;
      this.password_sys = '';
      this.reorganize_method = null;
      this.add_as_reserve_node = false;
      this.init();
    },

    startupshutdownNodes(method) {
      this.isLoading = true;
      let randomString = Math.random().toString(34).substring(2);
      xmlrpcservice.scalingRequest(
        JSON.stringify({
          method: method,
          db_ram: this.set_db_ram_automatically ? '' : this.db_ram,
          credentials: localStorage.credentials.split('Basic ')[1],
        }),
        randomString
      );

      let sleep = (time) => new Promise((resolve1) => setTimeout(resolve1, time));
      let done = false;
      let poll = (promiseFn, time) => {
        if (!done) {
          return promiseFn().then(sleep(time).then(() => poll(promiseFn, time)));
        }
      };
      let timeout = new Date().getTime() + 1800000;
      let timeout_reached;

      poll(
        () =>
          new Promise((resolve) =>
            axios.post(`${localStorage.proxyURL}/scalingrequestinfo/${randomString}`).then((response) => {
              timeout_reached = timeout < new Date().getTime();
              if (response.data != '' || timeout_reached) {
                done = true;
                this.isLoading = false;
                resolve(`Successfully run ${method}`);
              }
            })
          ),
        20000
      );
    },
  },
};
</script>

<style scoped></style>
